
import { useForm } from 'react-hook-form';
import { DynamicField } from './dynamic-field';
import type { BranchConfig } from '../types';
import type { QuestionnaireInput } from '../schema';

interface FinancialDetailsStepProps {
  /** Active branch config, picked by the parent based on `customer_type`. */
  branch:   BranchConfig | null;
  control:  ReturnType<typeof useForm<QuestionnaireInput>>['control'];
  register: ReturnType<typeof useForm<QuestionnaireInput>>['register'];
  watch:    ReturnType<typeof useForm<QuestionnaireInput>>['watch'];
  errors:   Partial<Record<keyof QuestionnaireInput, { message?: string }>>;
}

export function FinancialDetailsStep({
  branch,
  control,
  register,
  watch,
  errors,
}: FinancialDetailsStepProps) {
  // No branch (or empty fields) — nothing to ask. Tell the user to continue
  // rather than show a misleading "pick your customer type" message; Step 1
  // already validated the customer type before we got here.
  if (!branch || branch.fields.length === 0) {
    return (
      <div>
        <h2 className="text-xl font-semibold text-foreground mb-1">Your financial ecosystem</h2>
        <p className="text-sm text-muted-foreground">
          No extra questions for your category — click Continue to verify
          your identity.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-foreground mb-1">Your financial ecosystem</h2>
      <p className="text-sm text-muted-foreground mb-6">
        We leverage this to share best insights suited to you!
      </p>

      <div className="space-y-6">
        {branch.fields.map((field) => (
          <DynamicField
            key={field.name}
            field={field}
            control={control}
            register={register}
            watch={watch}
            errors={errors}
          />
        ))}
      </div>
    </div>
  );
}
